export default __webpack_public_path__ + "static/media/whatsapp.fdd4b700.png";